import { Color, LoadingManager, Scene } from "three";
// import { GuiHelper } from "../helpers/GuiHelper";
import { Sphere360 } from "../object/Sphere360";
import { PlanoHotSpot } from "../object/PlanoHotSpot";
import Emitter from "../../helpers/emitters";
import { GroupObjects } from "../helpers/GroupObjects";
import { Assets } from "../../assets";
import { ManagerLoaderTexture } from "../helpers/ManagerLoader";
import { createNewArrayPlaneTexture, createNewArrayTexture } from "../../helpers/loadTextureChangeLocation";

export class Scene1 extends Scene {
	constructor() {
		super();
		this.managerLoaderSphere = new LoadingManager();
		this.managerLoaderPlane = new LoadingManager();
		this.loaderTextureSPhere = new ManagerLoaderTexture(this.managerLoaderSphere);
		this.loaderTexturePlane = new ManagerLoaderTexture(this.managerLoaderPlane);
		this.groupPlanes = new GroupObjects();
		this.hotSpotArrow = [];
		this.planesHotSpotTexture = [];
		this.background = new Color("skyblue").convertSRGBToLinear();
		this.create();
		this.#emmitterOn();
		// this.helpers();
	}

	create() {
		this.view360 = new Sphere360(40, 64, 32);
		this.onUpdateView360();
		this.add(this.view360);
		// this.plano = new PlanoHotSpot("uno", 1, 1, { x: -10, y: 1, z: 0.6 });
		// this.add(this.plano);
	}

	onUpdateView360(url = Assets.texture.general.arial3) {
		this.managerLoaderSphere.onLoad = () => {
			this.view360.onUpdateTexture(this.loaderTextureSPhere.oneTexture);
			Emitter.emit("onLoadObject", true);
		};
		this.managerLoaderSphere.onProgress = (url, loaded, total) => {
			// console.log(url, loaded, total);
			Emitter.emit("onProcessObject", false);
		};
		this.managerLoaderSphere.onStart = () => {
			Emitter.emit("onProcessObject", false);
		};
		this.managerLoaderSphere.onError = (url) => {
			console.log("error loader", url);
		};
		this.loaderTextureSPhere.onUploadMeshBasic(url);
	}

	onCreatePlane(data = []) {
		const newArray = createNewArrayPlaneTexture(data);
		this.managerLoaderPlane.onLoad = () => {
			const newPlanes = this.loaderTexturePlane.multipleTexture.filter((plane) => !plane.hover);
			newPlanes.forEach(({ name, material, position }) => {
				const planeThree = new PlanoHotSpot(name, 3, 3, position);
				planeThree.onUpdateTexture(material);
				this.groupPlanes.onUploadGroup(planeThree);
			});
			this.add(this.groupPlanes);
			Emitter.emit("onLoadingButton", false);
		};
		this.loaderTexturePlane.onUploadMultipleTexture(newArray);
	}

	changeNewViewLocation(
		data = {
			hotspot: [],
		}
	) {
		const newArrayMaterial = createNewArrayTexture(data.hotspot);
		this.managerLoaderSphere.onLoad = () => {
			const hotspot = this.loaderTextureSPhere.multipleTexture.find((textures) => textures.name === "spot");
			const newArrayTexture = this.loaderTextureSPhere.multipleTexture
				.filter((textures) => textures.name !== "spot")
				.sort((a, b) => a.id - b.id);
			newArrayTexture.forEach(({ id, name, material, camarePosition, moveHotSpotArrow }, index) => {
				const planeThree = new PlanoHotSpot(name, 1, 1);
				planeThree.onUpdateTexture(hotspot.material);
				if (index === 0) {
					this.view360.onUpdateTexture(material);
				}
				planeThree.visible = false;
				this.hotSpotArrow.push({ name, material, camarePosition, id, moveHotSpotArrow });
				this.groupPlanes.onUploadGroup(planeThree);
			});
			this.add(this.groupPlanes);
			this.onVisibleHotSpotArrow(this.hotSpotArrow[0]);
			Emitter.emit("onLoadObject", true);
			Emitter.emit("activeTutorial", true);
		};
		this.loaderTextureSPhere.onUploadTexturesViewLocation(newArrayMaterial);
	}

	onChangeHotSpotMap(data) {
		this.onVisibleHotSpotArrow(data);
		// this.groupPlanes.onVisibleAnotherChild(data.name);
		this.view360.onUpdateTexture(data.material);
	}

	onVisibleHotSpotArrow(hotspot = {}) {
		const namesInitVisible = hotspot.moveHotSpotArrow.map((plane) => {
			return {
				...plane,
				name: `move-${plane.id}`,
			};
		});
		this.groupPlanes.onVisibleAnotherChildDynamic(namesInitVisible);
	}

	onChangeHoverPlane(data, hover) {
		if (hover) {
			const materiaSelect = this.loaderTexturePlane.multipleTexture.find((texture) => texture.hover && texture.name === data);
			if (materiaSelect) {
				this.groupPlanes.onChangeMaterialPlane(data, "", materiaSelect.material);
			}
		} else {
			const materiaSelect = this.loaderTexturePlane.multipleTexture.find((texture) => !texture.hover && texture.name === data);
			if (materiaSelect) {
				this.groupPlanes.onChangeMaterialPlane("", data, materiaSelect.material);
			}
		}
	}

	// helpers() {
	// 	const helpGui = new GuiHelper();
	// 	helpGui.objectsPosition(this.plano, "posion plano", -100, 100);
	// }

	cleanScene(number = 0) {
		if (number === 2) {
			this.loaderTextureSPhere.cleanMultipleTexture();
			this.hotSpotArrow = [];
		}
		this.loaderTexturePlane.cleanMultipleTexture();
		this.groupPlanes.children.forEach((child) => {
			this.remove(child);
		});
		this.groupPlanes.children = [];
		this.remove(this.groupPlanes);
	}

	onUpdateInitTexture() {
		this.view360.onUpdateTexture(this.loaderTextureSPhere.oneTexture);
	}

	#emmitterOn() {
		Emitter.on("onUpdatePlane", (data) => {
			Emitter.emit("onLoadingButton", true);
			this.onCreatePlane(data);
		});

		Emitter.on("clearPlanes", (menu = 0) => {
			this.cleanScene(menu);
			this.onUpdateInitTexture();
			// this.onUpdateView360();
		});

		Emitter.on("changeView", (data) => {
			this.cleanScene();
			this.changeNewViewLocation(data);
		});

		Emitter.on("hotspotArrow", (data) => {
			this.onChangeHotSpotMap(data);
		});

		Emitter.on("hoverHotSpot", (data) => {
			this.onChangeHoverPlane(data, true);
		});

		Emitter.on("cleanHover", (data) => {
			this.onChangeHoverPlane(data, false);
		});
	}

	update(camare = null) {
		this.groupPlanes.onLookAt(camare);
		// this.plano.lookAt(camare.position);
	}
}
